import { useMemo } from 'react'

import { SCOPE } from '@/constants'

import useScope from './useScope'

const getBreakpoint = (scope: string) => {
  switch (scope) {
    case SCOPE.NEMO_IOS:
      return 568
    case SCOPE.NEMO_ANDROID:
      return 640
    default:
      return 740
  }
}

export default function useRecaptchaBadgePosition() {
  const { scope } = useScope()

  const badge = useMemo(() => (window.innerHeight < getBreakpoint(scope) ? 'inline' : 'bottomleft'), [])
  return badge
}
